import vcMutilSelect from './src/vc-mutil-select'

vcMutilSelect.install = function (Vue) {
  Vue.component(vcMutilSelect.name, vcMutilSelect)
}

export default vcMutilSelect
